import React from 'react';
import camera from 'src/assets/icons/icon-camera.svg';
import cameraOff from 'src/assets/icons/icon-cameraOff.svg';
import microphone from 'src/assets/icons/icon-microphone.svg';
import microphoneOff from 'src/assets/icons/icon-microphoneOff.svg';
import contentShare from 'src/assets/icons/icon-share-screen.svg';
import SettingsIcon from 'src/assets/icons/icon-settings.svg';
import './icons-tray.scss';

interface Props {
  isVideoEnabled: boolean;
  toggleVideo: React.MouseEventHandler<HTMLDivElement>;
  muted: boolean;
  toggleAudioMute: React.MouseEventHandler<HTMLDivElement>;
  toggleContentShareCustom?: () => void;
  setShowModal: (show: boolean) => void;
  leaveMeeting: React.MouseEventHandler<HTMLButtonElement>;
  isTherapist: boolean;
  isFromMeetingRoom?: boolean;
  isMobileScreen?: boolean;
}

const IconsTray: React.FC<Props> = ({
  isVideoEnabled,
  toggleVideo,
  muted,
  toggleAudioMute,
  toggleContentShareCustom,
  setShowModal,
  leaveMeeting,
  isTherapist,
  isFromMeetingRoom = false,
  isMobileScreen = false,
}) => {
  return (
      <div className="icons-row">
        <div className="icons-container">
          <div className="video-icon-container"  onClick={toggleVideo}>
            <img
              src={isVideoEnabled ? camera : cameraOff}
              className="video-icon"
              alt="video icon"
            />
          </div>
          <div className="audio-icon-container" onClick={toggleAudioMute}>
            <img
              src={muted ? microphoneOff : microphone}
              className="audio-icon"
              alt="audio icon"
            />
          </div>
          {isFromMeetingRoom && !isMobileScreen && <button className="share-icon-container" onClick={toggleContentShareCustom}>
            <img
              src={contentShare}
              className="share-icon"
              alt="share screen icon"
            />
          </button>}
          <div
            className="cog-icon-container"
            onClick={() => setShowModal(true)}
          >
            <img
              src={SettingsIcon}
              className="audio-icon"
              alt="Settings icon"
            />
          </div>
        </div>
        {isFromMeetingRoom && <div className={'end-session-container'}>
          <button className={'end-session-button'} onClick={leaveMeeting}>
            {isTherapist ? 'End Session' : 'Leave Session'}
          </button>
        </div>}
      </div>
  );
};



export default IconsTray;
